import { combineReducers } from 'redux';

import check from './check';
import login from './login';
import resetPassword from './resetPassword';
import setNewPassword from './setNewPassword';
import acceptInvitation from './acceptInvitation';

export default combineReducers({ check, login, resetPassword, setNewPassword, acceptInvitation });
